var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10359:22129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.476 103.933H1.52343C0.682372 103.933 0 103.251 0 102.41V99.5242C0 98.6824 0.682372 98 1.52343 98H102.476C103.317 98 104 98.6824 104 99.5242V102.41C104 103.251 103.317 103.933 102.476 103.933Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.803 26.4004H78.1965V98.0662H25.803V26.4004Z",
    fill: "#FFEADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6064 20.9995C81.4729 20.9995 82.1759 21.7017 82.1759 22.569V25.0795C82.1759 25.9467 81.4729 26.6489 80.6064 26.6489H23.3934C22.527 26.6489 21.824 25.9467 21.824 25.0795V22.569C21.824 21.7025 22.527 20.9995 23.3934 20.9995H80.6064Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8032 42.5469H1.52344C0.682373 42.5469 0 41.8645 0 41.0226V38.4209C0 37.579 0.682373 36.8975 1.52344 36.8975H25.8032V42.5469Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0205 98.0662H37.9797V76.0041C37.9797 73.6102 39.9205 71.6694 42.3144 71.6694H61.6859C64.0797 71.6694 66.0197 73.6102 66.0197 76.0041V98.0662H66.0205Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4082 71.6699H53.5922V98.0667H50.4082V71.6699Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26709 42.5469H25.8034V98.0675H2.26709V42.5469Z",
    fill: "#FFEADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8203 42.5469H25.8024V98.0675H22.8203V42.5469Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.733 98.0667H78.197V42.5469H101.733V98.0667Z",
    fill: "#FFEADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1973 42.5469H81.1973V98.0675H78.1973V42.5469Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4357 54.441H33.1989C32.2951 54.441 31.5627 53.7079 31.5627 52.8041V39.1979C31.5627 38.2942 32.2951 37.561 33.1989 37.561H38.4357C39.3394 37.561 40.0718 38.2942 40.0718 39.1979V52.8041C40.0726 53.7079 39.3394 54.441 38.4357 54.441Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6183 54.441H49.3815C48.4777 54.441 47.7454 53.7079 47.7454 52.8041V39.1979C47.7454 38.2942 48.4777 37.561 49.3815 37.561H54.6183C55.522 37.561 56.2544 38.2942 56.2544 39.1979V52.8041C56.2544 53.7079 55.522 54.441 54.6183 54.441Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8009 54.441H65.5641C64.6603 54.441 63.928 53.7079 63.928 52.8041V39.1979C63.928 38.2942 64.6603 37.561 65.5641 37.561H70.8009C71.7047 37.561 72.437 38.2942 72.437 39.1979V52.8041C72.437 53.7079 71.7047 54.441 70.8009 54.441Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.653 78.7462H11.4169C10.5132 78.7462 9.78003 78.0131 9.78003 77.1093V63.5031C9.78003 62.5994 10.5132 61.8662 11.4169 61.8662H16.653C17.5575 61.8662 18.2899 62.5994 18.2899 63.5031V77.1093C18.2899 78.0139 17.5575 78.7462 16.653 78.7462Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3469 78.7462H92.5829C93.4866 78.7462 94.2198 78.0131 94.2198 77.1093V63.5031C94.2198 62.5994 93.4866 61.8662 92.5829 61.8662H87.3469C86.4423 61.8662 85.71 62.5994 85.71 63.5031V77.1093C85.71 78.0139 86.4423 78.7462 87.3469 78.7462Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.431 36.8975C103.298 36.8975 104 37.5997 104 38.4669V40.9774C104 41.8439 103.298 42.5469 102.431 42.5469H78.197V36.8975H102.431Z",
    fill: "#EF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 21V3.42064C66 1.53126 64.4979 0 62.6446 0H40.3554C38.5021 0 37 1.53126 37 3.42064V21H66Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 0V21H67V3.42064C67 1.53126 65.8274 0 64.3805 0H63Z",
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4017 8.90167H54.0983V5.59833C54.0983 4.71513 53.3832 4 52.5 4C51.6168 4 50.9017 4.71513 50.9017 5.59833V8.90167H47.5983C46.7159 8.90167 46 9.6168 46 10.5C46 11.3824 46.7159 12.0983 47.5983 12.0983H50.9017V15.4009C50.9017 16.2841 51.6168 17 52.5 17C53.3832 17 54.0983 16.2841 54.0983 15.4009V12.0975H57.4017C58.2841 12.0975 59 11.3824 59 10.4992C59 9.6168 58.2841 8.90167 57.4017 8.90167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10359:22129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.12195858a0f402b0d1b69d43f1bbbdd0.svg";
export { ForwardRef as ReactComponent };